function clockKey(slot) {
  return `${String(slot.start_time || '').slice(0, 5)}-${String(slot.end_time || '').slice(0, 5)}`;
}

export function commonFreeHours(teacher, selectedDays = []) {
  const days = [...new Set((selectedDays || []).map((d) => Number(d)).filter((d) => d >= 0 && d <= 6))];
  if (!days.length) return [];
  const byClock = new Map();
  for (const slot of teacher?.slotMatches || []) {
    if (slot.status !== 'free') continue;
    const key = clockKey(slot);
    if (!byClock.has(key)) byClock.set(key, new Set());
    byClock.get(key).add(Number(slot.day_of_week));
  }
  const common = [];
  for (const [key, daySet] of byClock) {
    if (days.every((d) => daySet.has(d))) {
      const [startTime, endTime] = key.split('-');
      common.push({ startTime, endTime });
    }
  }
  common.sort((a, b) => String(a.startTime).localeCompare(String(b.startTime)));
  return common;
}

export function rebucketTeachersForWindow(available, partial, unavailable, selectedDays = []) {
  const all = [...(available || []), ...(partial || []), ...(unavailable || [])];
  const best = [];
  const some = [];
  const none = [];
  for (const teacher of all) {
    const freeCount =
      teacher.matchCount ??
      (teacher.slotMatches || []).filter((s) => s.status === 'free').length;
    if (freeCount <= 0) {
      none.push(teacher);
      continue;
    }
    const hours = commonFreeHours(teacher, selectedDays);
    if (hours.length > 0) {
      best.push({ ...teacher, bestFitHours: hours });
    } else {
      some.push({ ...teacher, bestFitHours: [] });
    }
  }
  best.sort(
    (a, b) =>
      (b.bestFitHours?.length || 0) - (a.bestFitHours?.length || 0) ||
      (a.busyHours || 0) - (b.busyHours || 0) ||
      String(a.name || '').localeCompare(String(b.name || ''))
  );
  some.sort(
    (a, b) =>
      (b.matchCount || 0) - (a.matchCount || 0) ||
      (a.busyHours || 0) - (b.busyHours || 0) ||
      String(a.name || '').localeCompare(String(b.name || ''))
  );
  return { exact: best, partial: some, unavailable: none };
}

export function schedulesHaveSlots(schedules) {
  return Object.values(schedules || {}).some((slots) => Array.isArray(slots) && slots.length > 0);
}

export function prefillSchedulesFromTeacher(teacher, selectedDays = [], fallbackSchedules = null) {
  const schedules = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [] };
  const days = (selectedDays || []).map((d) => Number(d)).filter((d) => d >= 0 && d <= 6);
  const common = commonFreeHours(teacher, days);
  if (common[0]) {
    days.forEach((day) => {
      schedules[day].push({ startTime: common[0].startTime, endTime: common[0].endTime });
    });
    return schedules;
  }
  for (const slot of teacher?.slotMatches || []) {
    if (slot.status !== 'free') continue;
    const day = Number(slot.day_of_week);
    if (day < 0 || day > 6 || schedules[day].length) continue;
    schedules[day].push({
      startTime: String(slot.start_time).slice(0, 5),
      endTime: String(slot.end_time).slice(0, 5),
    });
  }
  if (!schedulesHaveSlots(schedules) && fallbackSchedules) {
    return fallbackSchedules;
  }
  return schedules;
}
